import {withStyles} from '@material-ui/core/styles'
import {ToggleButtonGroup} from '@material-ui/lab'

import {theme} from '../theme'

const styles = {
  root: {
    overflow: 'hidden',
    width: '100%',
    backgroundColor: theme.palette.grey[300],
    padding: 2,
  },
  groupedHorizontal: {
    '&:not(:first-child)': {
      borderTopLeftRadius: 'inherit',
      borderBottomLeftRadius: 'inherit',
    },
    '&:not(:last-child)': {
      borderTopRightRadius: 'inherit',
      borderBottomRightRadius: 'inherit',
    },
  },
}

export default withStyles(styles, {name: 'LPCToggleButtonGroup'})(ToggleButtonGroup)
